import apiFetch from '../../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/${dossierId}/PerformDoubleTransferFromSale`, method: 'PUT', body: null, token: token, lastAccessDate })
}
